import { ReactNode } from 'react';

import { FINISHED_STATUS } from '../../pages/IdealCustomerProfile/constants';
import { useFitModel } from '../../pages/IdealCustomerProfile/useFitModel';

type WhenFitScoreProps = {
  children: ReactNode;
};
export function WhenFitScore({ children }: WhenFitScoreProps) {
  const hasFitScoreEnabled = useFitScoreEnabled();

  return hasFitScoreEnabled ? children : null;
}

export function useFitScoreEnabled() {
  const { data } = useFitModel();

  return data?.status === FINISHED_STATUS;
}
